import './style.scss'

import 'header'
import 'footer'
import 'jquery.scrollbar'

var saveAs=saveAs||function(e){"use strict";if(typeof e==="undefined"||typeof navigator!=="undefined"&&/MSIE [1-9]\./.test(navigator.userAgent)){return}var t=e.document,n=function(){return e.URL||e.webkitURL||e},r=t.createElementNS("http://www.w3.org/1999/xhtml","a"),o="download"in r,a=function(e){var t=new MouseEvent("click");e.dispatchEvent(t)},i=/constructor/i.test(e.HTMLElement)||e.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),u=function(t){(e.setImmediate||e.setTimeout)(function(){throw t},0)},s="application/octet-stream",d=1e3*40,c=function(e){var t=function(){if(typeof e==="string"){n().revokeObjectURL(e)}else{e.remove()}};setTimeout(t,d)},l=function(e,t,n){t=[].concat(t);var r=t.length;while(r--){var o=e["on"+t[r]];if(typeof o==="function"){try{o.call(e,n||e)}catch(a){u(a)}}}},p=function(e){if(/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)){return new Blob([String.fromCharCode(65279),e],{type:e.type})}return e},v=function(t,u,d){if(!d){t=p(t)}var v=this,w=t.type,m=w===s,y,h=function(){l(v,"writestart progress write writeend".split(" "))},S=function(){if((f||m&&i)&&e.FileReader){var r=new FileReader;r.onloadend=function(){var t=f?r.result:r.result.replace(/^data:[^;]*;/,"data:attachment/file;");var n=e.open(t,"_blank");if(!n)e.location.href=t;t=undefined;v.readyState=v.DONE;h()};r.readAsDataURL(t);v.readyState=v.INIT;return}if(!y){y=n().createObjectURL(t)}if(m){e.location.href=y}else{var o=e.open(y,"_blank");if(!o){e.location.href=y}}v.readyState=v.DONE;h();c(y)};v.readyState=v.INIT;if(o){y=n().createObjectURL(t);setTimeout(function(){r.href=y;r.download=u;a(r);h();c(y);v.readyState=v.DONE});return}S()},w=v.prototype,m=function(e,t,n){return new v(e,t||e.name||"download",n)};if(typeof navigator!=="undefined"&&navigator.msSaveOrOpenBlob){return function(e,t,n){t=t||e.name||"download";if(!n){e=p(e)}return navigator.msSaveOrOpenBlob(e,t)}}w.abort=function(){};w.readyState=w.INIT=0;w.WRITING=1;w.DONE=2;w.error=w.onwritestart=w.onprogress=w.onwrite=w.onabort=w.onerror=w.onwriteend=null;return m}(typeof self!=="undefined"&&self||typeof window!=="undefined"&&window||this.content);if(typeof module!=="undefined"&&module.exports){module.exports.saveAs=saveAs}else if(typeof define!=="undefined"&&define!==null&&define.amd!==null){define("FileSaver.js",function(){return saveAs})}
var ics=function(e,t){"use strict";{if(!(navigator.userAgent.indexOf("MSIE")>-1&&-1==navigator.userAgent.indexOf("MSIE 10"))){void 0===e&&(e="default"),void 0===t&&(t="Calendar");var r=-1!==navigator.appVersion.indexOf("Win")?"\r\n":"\n",n=[],i=["BEGIN:VCALENDAR","PRODID:"+t,"VERSION:2.0"].join(r),o=r+"END:VCALENDAR",a=["SU","MO","TU","WE","TH","FR","SA"];return{events:function(){return n},calendar:function(){return i+r+n.join(r)+o},addEvent:function(t,i,o,l,u,s){if(void 0===t||void 0===i||void 0===o||void 0===l||void 0===u)return!1;if(s&&!s.rrule){if("YEARLY"!==s.freq&&"MONTHLY"!==s.freq&&"WEEKLY"!==s.freq&&"DAILY"!==s.freq)throw"Recurrence rrule frequency must be provided and be one of the following: 'YEARLY', 'MONTHLY', 'WEEKLY', or 'DAILY'";if(s.until&&isNaN(Date.parse(s.until)))throw"Recurrence rrule 'until' must be a valid date string";if(s.interval&&isNaN(parseInt(s.interval)))throw"Recurrence rrule 'interval' must be an integer";if(s.count&&isNaN(parseInt(s.count)))throw"Recurrence rrule 'count' must be an integer";if(void 0!==s.byday){if("[object Array]"!==Object.prototype.toString.call(s.byday))throw"Recurrence rrule 'byday' must be an array";if(s.byday.length>7)throw"Recurrence rrule 'byday' array must not be longer than the 7 days in a week";s.byday=s.byday.filter(function(e,t){return s.byday.indexOf(e)==t});for(var c in s.byday)if(a.indexOf(s.byday[c])<0)throw"Recurrence rrule 'byday' values must include only the following: 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'"}}var g=new Date(l),d=new Date(u),f=new Date,S=("0000"+g.getFullYear().toString()).slice(-4),E=("00"+(g.getMonth()+1).toString()).slice(-2),v=("00"+g.getDate().toString()).slice(-2),y=("00"+g.getHours().toString()).slice(-2),A=("00"+g.getMinutes().toString()).slice(-2),T=("00"+g.getSeconds().toString()).slice(-2),b=("0000"+d.getFullYear().toString()).slice(-4),D=("00"+(d.getMonth()+1).toString()).slice(-2),N=("00"+d.getDate().toString()).slice(-2),h=("00"+d.getHours().toString()).slice(-2),I=("00"+d.getMinutes().toString()).slice(-2),R=("00"+d.getMinutes().toString()).slice(-2),M=("0000"+f.getFullYear().toString()).slice(-4),w=("00"+(f.getMonth()+1).toString()).slice(-2),L=("00"+f.getDate().toString()).slice(-2),O=("00"+f.getHours().toString()).slice(-2),p=("00"+f.getMinutes().toString()).slice(-2),Y=("00"+f.getMinutes().toString()).slice(-2),U="",V="";y+A+T+h+I+R!=0&&(U="T"+y+A+T,V="T"+h+I+R);var B,C=S+E+v+U,j=b+D+N+V,m=M+w+L+("T"+O+p+Y);if(s)if(s.rrule)B=s.rrule;else{if(B="rrule:FREQ="+s.freq,s.until){var x=new Date(Date.parse(s.until)).toISOString();B+=";UNTIL="+x.substring(0,x.length-13).replace(/[-]/g,"")+"000000Z"}s.interval&&(B+=";INTERVAL="+s.interval),s.count&&(B+=";COUNT="+s.count),s.byday&&s.byday.length>0&&(B+=";BYDAY="+s.byday.join(","))}(new Date).toISOString();var H=["BEGIN:VEVENT","UID:"+n.length+"@"+e,"CLASS:PUBLIC","DESCRIPTION:"+i,"DTSTAMP;VALUE=DATE-TIME:"+m,"DTSTART;VALUE=DATE-TIME:"+C,"DTEND;VALUE=DATE-TIME:"+j,"LOCATION:"+o,"SUMMARY;LANGUAGE=en-us:"+t,"TRANSP:TRANSPARENT","END:VEVENT"];return B&&H.splice(4,0,B),H=H.join(r),n.push(H),H},download:function(e,t){if(n.length<1)return!1;t=void 0!==t?t:".ics",e=void 0!==e?e:"calendar";var a,l=i+r+n.join(r)+o;if(-1===navigator.userAgent.indexOf("MSIE 10"))a=new Blob([l]);else{var u=new BlobBuilder;u.append(l),a=u.getBlob("text/x-vCalendar;charset="+document.characterSet)}return saveAs(a,e+t),l},build:function(){return!(n.length<1)&&i+r+n.join(r)+o}}}console.log("Unsupported Browser")}};
var cal_single = ics();

$(function() {
  var isIE = Boolean(window.navigator.userAgent.indexOf('MSIE ') >= 0 || window.navigator.userAgent.indexOf('Trident/') >= 0 || window.navigator.userAgent.indexOf(' Edg') >= 0);
  
  //tabFn();
  tabFnUpdate();
  pgBtmShortcut();
  upcomingEvents();
  otherSportShortcut();
  expanditemFun();
  fsItems();
  galleryItem();
  readMoreFn();
  formInputFocusFn();
  filterSelect();
  checkArchor();
  genTableWrapper();
  customScrollbar();


  //for close the pop-up note
  closePopUpNote();

  //eshop for
  eshopTabSel();
  eshopStickyBar();
  checkBoxList();

  //share social media
  shareSocialFunction();
  
  
  // console.log('isIE: ', isIE);
  if (isIE) {
    downloadICS();
  } else {
    addToCart();
  }

  footerDisplay();

  var isMobile = checkMobile();
  if (!isMobile) {
    $('body').addClass('isDesktop')
  } else {
    $('body').removeClass('isDesktop')
  }


  setTimeout(function() {
    sectionIntro();
  }, 1000)
 

  $('input[type="text"]').attr('autocomplete','off');

})


 

//footer display for short height issue
function footerDisplay(){
  if ($('.master').height()<=900) {
    $('footer').addClass('sticky');
  }
}

//Share social function
function shareSocialFunction() {
    var url = window.location.href;
 
    //Facebook share
    $('.social-share a.shareFB').on('click', function(event) {
        event.preventDefault();
        var shareURL = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
        window.open(shareURL,'cssSocialMediaPopup','menubar=1,resizable=1,width=500,height=500');
        return false;
    });
 
    //Twitter share
    $('.social-share a.shareTwitter').on('click', function(event) {
        event.preventDefault();
        var title = $("meta[property='og:title']").attr("content") + "\n" + $("meta[property='og:description']").attr("content");
        var shareURL = 'http://twitter.com/share?text=' + encodeURIComponent(title);
        window.open(shareURL,'cssSocialMediaPopup','menubar=1,resizable=1,width=500,height=500');
        return false;
    });

    //Whatsapp share
    $('.social-share .shareWhatapps').on('touchend click', function(event) {
      event.preventDefault();
      var shareURL = 'https://www.addtoany.com/add_to/whatsapp?linkurl=' + encodeURIComponent(url);

      window.open(shareURL,'cssSocialMediaPopup','menubar=1,resizable=1,width=500,height=250');
      return false;
    });

    //Email
    $('.social-share a.shareEmail').on('click', function(event) {
      event.preventDefault();
      
			// var textSubject;	
			// var emailBody = "\%0A" + textName + ": " + $("#contact-Name").val() + "\%0A" + textEmail + ": " + $("#contact-email").val() + "\%0A" + textPhone + ": " + $("#contact-contact-no").val() + "\%0A" + textOption + ":\%0A" + $("#contact-opinion").val() + "\%0A\%0A" + textCommon + "\%0A\%0A";
      // location.href = "mailto:dutchlady.hk@frieslandcampina.com?" + "&body=" + emailBody + "&subject=" + textSubject;
      var emailBody = "Link:" + encodeURIComponent(url) + "\%0A\%0A";
      var title = $("meta[property='og:title']").attr("content");
      location.href = "mailto:?" + "&body=" + emailBody + "&subject=" + title;
      return false;
    });
    
}

//Add to Calendar - for not IE
function addToCart() {
  
  $(".addToCalendarBtn").bind('click', function() {
    
    // /<span class="statTime">25-Nov-2020 12:00</span>
    var dateArrayStart = $(".statTime").text().split(' ');
    var dateStart = dateArrayStart[0].split('-');  
    if (dateArrayStart.length > 1) {
      var startTime = dateArrayStart[1].split(':');
    }      
    

    var dateArrayEnd = $(".endTime").text().split(' ');
    var dateEnd = dateArrayEnd[0].split('-');  
    if (dateArrayEnd.length > 1) {
      var endTime = dateArrayEnd[1].split(':');
    }        
    

    var currentStartM;
    var currentEndM;
    var currentStartMNum;
    var currentEndMNum;

    var monthArray = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    $(monthArray).each(function(i) {
      if (dateStart[1] == monthArray[i]) {
        currentStartMNum = (i + 1);
        if (currentStartMNum < 10) {
          currentStartM = "0" + currentStartMNum;
        } else {
          currentStartM = currentStartMNum;
        }
      }
      if (dateEnd[1] == monthArray[i]) {
        currentEndMNum = (i + 1);
        if (currentEndMNum < 10) {
          currentEndM = "0" + currentEndMNum;
        } else {
          currentEndM = currentEndMNum;
        }
      }
    })
    
    //20201126T134000
    if (dateArrayStart.length > 1) {
      var msgData1 = dateStart[2] + currentStartM + dateStart[0] + 'T' + startTime[0] + startTime[1] + '00';
    } else {
      var msgData1 = dateStart[2] + currentStartM + dateStart[0] + 'T000000';
    }
    if (dateArrayEnd.length > 1) {
      var msgData2 = dateEnd[2] + currentEndM + dateEnd[0] + 'T' + endTime[0] + endTime[1] + '00';	
    } else {
      var msgData2 = dateEnd[2] + currentEndM + dateEnd[0] + 'T230000';;
    }
    //var title = event.title;
    var title = $("h1 span").eq(0).text();
    var location = "";
      
    // console.log("msgData1:" + msgData1)
    // console.log("msgData2:" + msgData2)
    // var location = "Room B 7/F 128 Wellington Street Central";
    
    
    var icsMSG = escape("BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//Our Company//NONSGML v1.0//EN\nBEGIN:VTIMEZONE\nTZID:Asia/Hong_Kong\nX-LIC-LOCATION:Asia/Hong_Kong\nBEGIN:STANDARD\nTZNAME:HKST\nTZOFFSETTO:+0800\nEND:STANDARD\nEND:VTIMEZONE\nBEGIN:VEVENT\nDTSTAMP:" + msgData1 + "\nSTATUS:CONFIRMED\nDTSTART:" + msgData1 + "\nDTEND:" + msgData2 + "\nSUMMARY:" + title + "\nLOCATION:") + location + escape("\nEND:VEVENT\nEND:VCALENDAR");
    
    var uri = "data:text/calendar;charset=utf8," + icsMSG;
    ////this trick will generate a temp tag
    var link = document.createElement("a");
    link.href = uri;
    //set the visibility hidden so it will not effect on your web-layout
    link.style = "display:none";
    link.download = "events-calendar.ics";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  })  
 
}

////download icsfile for IE only
function downloadICS() {
  
  $(".addToCalendarBtn").bind('click', function() {  
    
      // /<span class="statTime">25-Nov-2020 12:00</span>
      var dateArrayStart = $(".statTime").text().split(' ');
      var dateStart = dateArrayStart[0].split('-');        
      if (dateArrayStart.length > 1) {
        var startTime = dateArrayStart[1].split(':');
      }  

      var dateArrayEnd = $(".endTime").text().split(' ');
      var dateEnd = dateArrayEnd[0].split('-');        
      if (dateArrayEnd.length > 1) {
        var endTime = dateArrayEnd[1].split(':');
      }   

      var currentStartM;
      var currentEndM;
      var currentStartMNum;
      var currentEndMNum;

      var monthArray = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      $(monthArray).each(function(i) {
        if (dateStart[1] == monthArray[i]) {
          currentStartMNum = (i + 1);
          currentStartM = currentStartMNum;
        }
        if (dateEnd[1] == monthArray[i]) {
          currentEndMNum = (i + 1);
          currentEndM = currentEndMNum;
        }
      })
      
      //20201125T100000
      // var msgData1 = dateStart[0] + dateStart[1] + dateStart[2] + 'T' + startTime[0] + startTime[1] + '00';
      // var msgData2 = dateStart[0] + dateStart[1] + dateStart[2] + 'T' + endTime[0] + endTime[1] + '00';	
      
      if (dateArrayStart.length > 1) {
        //11/26/2020 6:30 pm
        var tempHr = startTime[0];
        var tempAPMStart = "am";
        if (startTime[0] > 12) {
            tempHr = startTime[0]-12;
            tempAPMStart = "pm";
        } else if (startTime[0] == 12) {
            tempAPMStart = "pm";
        } else {
            tempHr = startTime[0];
            tempAPMStart = "am";
        }
        //dateStart[2] + currentStartM + dateStart[0]
        //11/26/2020 5:30 pm
        // /msgData1:10/2020/28 12:00 pm
        var msgData1 = currentStartM + "/" + dateStart[0] + "/" + dateStart[2] + ' ' + tempHr + ":" + startTime[1] + ' ' + tempAPMStart;
        //console.log("msgData1:" + msgData1)
      } else {
        var msgData1 = currentStartM + "/" + dateStart[0] + "/" + dateStart[2] + ' 0:00 am';
      }

      if (dateArrayEnd.length > 1) {
        var tempHrEnd = endTime[0];
        var tempAPMEnd = "am";
        if (endTime[0] > 12) {
            tempHrEnd = endTime[0]-12;
            tempAPMEnd = "pm";
        } else if (endTime[0] == 12) {
            tempAPMEnd = "pm";
        } else {
            tempHrEnd = endTime[0];
            tempAPMEnd = "am";
        }
        var msgData2 = currentEndM + "/" + dateEnd[0] + "/" + dateEnd[2] + ' ' + tempHrEnd + ":" + endTime[1] + ' ' + tempAPMEnd;
      } else {
        var msgData2 = currentEndM + "/" + dateEnd[0] + "/" + dateEnd[2] + ' 11:00 pm';
      }

      // console.log("msgData1:" + msgData1)
      // console.log("msgData2:" + msgData2)
      //var title = event.title;
      var title = $("h1 span").eq(0).text();
      var location = "";

    // cal_single.addEvent('Best Day22', 'This is the best day to demonstrate a single event.', 'New York', '11/26/2020 5:30 pm', '11/26/2020 6:30 pm');   
      cal_single.addEvent(title, ' ', location, msgData1, msgData2);   
      cal_single.download('events-calendar-ie');
  });
}

//close pop-up note
function closePopUpNote() {
  $(".closePopUpNote").bind("click" , function() {
    $(".popUpNotice").remove();
  })
}


function checkBoxList(){
  $('.checkbox-list .field-checkbox').click(function(){
    if(!$(this).hasClass('radio')){
      $(this).toggleClass('checked');
    }else{
      $(this).parent().find('.field-checkbox').removeClass('checked');
      $(this).addClass('checked');
    }
  });

  $('.field-switch-btn').click(function(){
    $(this).toggleClass('checked');
  });
}


function eshopStickyBar(){
  if ($('.tab-eshop-cat').is(':visible')) {
      $('.tab-eshop-cat').on('onscreen',function(event, measurement) {
        if (measurement.percentFromTop <= 0){
          $(this).addClass('sticky');
          $('.eshop-sticky-box').addClass('sticky');
        }
      });
      $('.eshop-top-intro').on('onscreen',function(event, measurement) {
        if (measurement.percentFromTop >= 0){
          $('.tab-eshop-cat, .eshop-sticky-box').removeClass('sticky');
        }
      });
  }
}

function eshopTabSel(){

  if (!$('.eshop-products').is(':visible')) {
    var _tabName = getUrlParameter('productCat');
    if (_tabName) {
      $('.tab-eshop-cat a').removeClass('on');
      $('.tab-eshop-cat #'+_tabName).addClass('on');

      var selItemPos = Math.floor($('.component-tab a.on').position().left * 0.9);

      $('.component-tab').animate({
        scrollLeft: selItemPos
      }, 500);
    }

  }
}

function customScrollbar(){
  $('.scrollbar-dynamic').scrollbar();
}

function formInputFocusFn() {

  if ($("form").is(':visible')) {

    $('.comp-sel select').on('change', function() {
      $(this).parent().parent().addClass('on');
    });

    $('.module-reg-form input').focus(function() {
      $('.comp-sel').removeClass('on');
    });

    $(window).on('scroll', function() {
      $('.comp-sel').removeClass('on');
    });

    $('.group input').focusout(function() {
      var _valLgth = $(this).val().length;
      if (_valLgth > 0) {
        $(this).parent().addClass('on');
      } else {
        $(this).parent().removeClass('on');
      }
    });

  }
}

function readMoreFn() {
  var _toggleClass = 'on';
  if ($(".module-toggle-read-more").is(':visible')) {
    $(".module-toggle-read-more").each(function() {
      var _moduleHtt = $(this).find('.container').height();
      $(this).attr('data-module-ht', _moduleHtt);
      $(this).find('.container').css('height', _moduleHtt * 0.4);
    });
    $(".module-toggle-read-more .btn-read-more").click(function() {
      var $parent = $(this).parent().parent();
      var _moduleHt = $parent.attr('data-module-ht');
      $(this).toggleClass(_toggleClass);
      $parent.toggleClass(_toggleClass);
      if ($(this).hasClass(_toggleClass)) {
        $parent.find('.container').css('height', _moduleHt);
      } else {
        $parent.find('.container').css('height', _moduleHt * .3);
      }
    });
  }
}

function fsItems() {

  if ($(".module-fs-items").is(':visible')) {
    $(".module-fs-items ul").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      infinite: true,
      arrows: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }]
    });
  }

}


function upcomingEvents() {

  if ($(".module-upcoming-events").is(':visible')) {
    $(".module-upcoming-events ul").slick({
      slidesToShow: 4,
      dots: false,
      infinite: true,
      arrows: true,
      variableWidth: true,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          arrows: false
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          variableWidth: true
        }
      }]
    });
  }

}
function sectionIntro() {
  if ($(".module-intro").is(':visible')) {
    $('.module-intro').each(function () {
      var _displayCounter, _displayArrow;

      var _slides = $(this).find(".inner-wrapper>ul>li");

      if ($(_slides).length <= 3) {
        _displayCounter = 3;
        //_displayArrow = false;
        $(this).find('.slide-progress-bar').hide();
      } else {
        _displayCounter = 4;
        //_displayArrow = true;
        $(this).find('.slide-progress-bar').show();
      }


      $(this).addClass('items-' + _displayCounter);
      $(this).attr('data-item-count',$(_slides).length);
      var _slideLgth = $(_slides).length;

      if (_slideLgth < 4) {
        $(this).addClass('static');
        
      }

      $(this).find('.slide-progress-bar span').css('width', $(this).find('.slide-progress-bar').outerWidth() / _slideLgth);
      $(this).find('.inner-wrapper>ul').slick({
        slidesToShow: _displayCounter,
        arrows: true,
        infinite: false,
        responsive: [{
          breakpoint: 860,
          settings: {
            slidesToShow: 3,
            dots: false,
            infinite: false,
            arrows: true,
            variableWidth: true
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: false,
            infinite: false,
            arrows: true,
            variableWidth: true
          }
        }]
      });
      $(this).find('.inner-wrapper>ul').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var _widRange = $(this).parent().find('.slide-progress-bar').outerWidth() / slick.slideCount;

        $(this).parent().find('.slide-progress-bar span').css('width', (nextSlide + 1) * _widRange);
      });
    });

    // $(window).on('resize',function(){
    //   if($(this).width()>900){
    //     var $slider = $('.module-intro');
    //
    //     $slider.each(function(){
    //       var _slideLgth = $(this).attr('data-item-count');
    //
    //       console.log(_slideLgth);
    //       if (_slideLgth < 4) {
    //       }
    //
    //     });
    //
    //   };
    // });

  }
}



//comment below function as use PRD one instead
// function sectionIntro() {

//   if (!$('body').hasClass('isDesktop')) {

//     console.log($('body').hasClass('isDesktop'));

//     if ($(".module-intro").is(':visible')) {

//       $('.module-intro').each(function(){
//         var _displayCounter,
//           _displayArrow;
//         var _slides = $(this).find(".inner-wrapper>ul>li");

//         if ($(_slides).length <= 3) {
//           _displayCounter = 3;
//           _displayArrow = false;
//         } else {
//           _displayCounter = 4;
//           _displayArrow = true;
//         }

//         //console.log(_displayCounter, _displayArrow);

//         $(this).addClass('items-' + _displayCounter);

//         var _slideLgth = $(_slides).length;

//         if (_slideLgth < 4) {
//           $(this).addClass('static');
//           $(this).find('.slide-progress-bar').css('display', 'none');
//         }
//         /* Slider settings */
//         var settings = {
//           slidesToShow: _displayCounter,
//           arrows: _displayArrow,
//           responsive: [{
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1,
//               dots: false,
//               infinite: false,
//               arrows: true,
//               variableWidth: true
//             }
//           }, {
//             breakpoint: 768,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1,
//               dots: false,
//               infinite: false,
//               arrows: true,
//               variableWidth: true
//             }
//           }]
//         }


//         $(this).find('.slide-progress-bar span').css('width',  $(this).find('.slide-progress-bar').outerWidth() / _slideLgth);

//         $(this).find('.inner-wrapper>ul').slick(settings);

//         $(this).find('.inner-wrapper>ul').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
//           var _widRange = $(this).parent().find('.slide-progress-bar').outerWidth() / slick.slideCount;
//           $(this).parent().find('.slide-progress-bar span').css('width', (nextSlide + 1) * _widRange);
//         });
//       });

//     }
//   }

// }

function pgBtmShortcut() {
  if ($('.toolWrapper').is(':visible')) {
    $(".toolWrapper").slick({
      slidesToShow: 3,
      arrows: false,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: true
        }
      }]
    });
  }
}

function otherSportShortcut() {
  if ($('.sportsList').is(':visible')) {
    $(".sportsList").slick({
      slidesToShow: 4,
      arrows: true,
      infinite: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 3

        }
      }]
    });
  }
}

//component: tab
// function tabFn() {
//   if ($('.component-tab nav').is(':visible')) {
//
//     //Tab status: Static Links
//
//     if ($(window).width() < 1119) {
//       $('.component-tab nav').each(function() {
//         var liItems = $(this);
//         var Sum = 0;
//         if (liItems.find('a').length >= 1) {
//           $(this).find('a').each(function(i, e) {
//             Sum += $(e).outerWidth();
//           });
//
//           if (liItems.find('a').length <= 5) {
//             //  Sum = Sum*1.4;
//             Sum = Sum + 10;
//             $(this).addClass('short');
//           } else {
//             $(this).addClass('long');
//           }
//           $(this).css('width', Sum);
//         }
//       })
//
//       var selItemPos = Math.floor($('.component-tab a.on').position().left * 0.9);
//
//       $('.component-tab').animate({
//         scrollLeft: selItemPos
//       }, 500);
//     }
//
//     $('[data-tab-content].on').show();
//
//     //Tab status: Targeted ID
//     $('[data-item-tab]').click(function() {
//       var _targetId = $(this).data('item-tab');
//
//       $('[data-item-tab]').removeClass('on');
//       $(this).addClass('on');
//       $('[data-tab-content]').hide();
//       $('[data-tab-content=' + _targetId + ']').fadeIn();
//     });
//
//   }
// }

function tabFnUpdate() {
  if ($('.component-tab').not('.tab-eshop-cat').find('.nav').is(':visible')) {

    //Tab status: Static Links
    var selItemPos = Math.floor($('.component-tab a.on').position().left * 0.9);

    $('.component-tab').animate({
      scrollLeft: selItemPos
    }, 500);

    $('[data-tab-content].on').show();

    //Tab status: Targeted ID
    $('[data-item-tab]').click(function() {
      var _targetId = $(this).data('item-tab');

      $('[data-item-tab]').removeClass('on');
      $(this).addClass('on');
      $('[data-tab-content]').hide();
      $('[data-tab-content=' + _targetId + ']').fadeIn();
    });

  }
}

//Expand items
function expanditemFun() {
  if ($('.expandItem').is(':visible')) {

    $('.expandItem').each(function() {
      $(this).click('bind', function() {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).find('.expandDetail').slideUp(500);
        } else {
          $(this).addClass('active');
          $(this).find('.expandDetail').slideDown(500);
        }

      })
    })
  }
}

//Gallery item
function galleryItem() {
  if ($('.galleryWrapper').is(':visible')) {

    var totalNumber;
    var currentNum;
    var slideLimit = 5;

    $(".galleryWrapper").on("init", function(event, slick) {
      //console.log(slick.slideCount);
      //console.log(slick.currentSlide+1);
      totalNumber = slick.slideCount;
      currentNum = slick.currentSlide + 1;


    });
    // $(window).on('resize', function() {
    // 	$('.galleryWrapper .slick-track').height('auto');
    // 	$('.galleryWrapper .slick-slide').height('auto');
    // 	console.log($('.galleryWrapper .slick-track').height())
    // 	$('.galleryWrapper .slick-slide').height($('.galleryWrapper .slick-track').height())
    // }).trigger('resize');

    $(".galleryWrapper").slick({
      slidesToShow: 1,
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000
    });



    //galleryWrapper
    if (totalNumber > slideLimit) {
      $('.galleryWrapper .slick-dots').addClass('hidden');
      var numberCountArea = $('<div/>', {
        'class': 'numberCountArea'
      });
      $('.galleryWrapper').append(numberCountArea);
      $(numberCountArea).text(currentNum + '/' + totalNumber);

      $(".galleryWrapper").on("afterChange", function(event, slick, currentSlide) {
        //console.log(currentSlide+1);
        currentNum = currentSlide + 1;
        $(numberCountArea).text(currentNum + '/' + slick.slideCount);
      });
    } else {
      $('.galleryWrapper .slick-arrow').addClass('hidden');
    }



  }

  if ($('.module-list-thumb').is(':visible')) {
    $('.module-list-thumb .list-thumb .thumb').each(function(){
      var _bgImgSrc = $(this).find('img').attr('src');
      $(this).css('background-image','url('+_bgImgSrc+')');
    });
  }

}

function filterSelect() {

  if ($('.box-filtering #year').length > 0) {
    var currectFilter = getUrlParameter('year');
    if (currectFilter) {
      $('.box-filtering #year option[id=' + currectFilter + ']').prop("selected", true);
    }

    $('.box-filtering #year').bind('change', function() {
      window.location = $(this).val();
    })
  }

  if ($('.box-filtering #type').length > 0) {
    var currectFilterType = getUrlParameter('type');
    var curSportType = getUrlParameter('sports');

    if (currectFilterType) {
      $('.box-filtering #type option[id=' + currectFilterType + ']').prop("selected", true);
      if (currectFilterType=='Sports') {
        $('.event-top-bar').addClass('displayChild');
        if(curSportType){
          $('.box-filtering #sportsTag option[id=' + curSportType + ']').prop("selected", true);
        };
      }
    }

    $('.box-filtering #type, .box-filtering #sportsTag').bind('change', function() {
      window.location = $(this).val();
    })
  }

}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.href);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, '    '));
};

// function GetParam(name) {
//   var start = location.search.indexOf("?" + name + "=");
//   if (start < 0) start = location.search.indexOf("&" + name + "=");
//   if (start < 0) return '';
//   start += name.length + 2;
//   var end = location.search.indexOf("&", start) - 1;
//   if (end < 0) end = location.search.length;
//   var result = location.search.substring(start, end);
//   var result = '';
//   for (var i = start; i <= end; i++) {
//     var c = location.search.charAt(i);
//     result = result + (c == '+' ? ' ' : c);
//   }
//   //alert(unescape(result));
//   return unescape(result);
// }

function checkArchor() {
    var currectFilter = getUrlParameter('link');

    if (currectFilter) {

      $('html, body').animate(
        {
          scrollTop: $("#"+currectFilter).offset().top - 150,
        },
        500,
        'linear'
      )
    }
}
function genTableWrapper() {
  if ($('.facilitiesContent table').length > 0) {
    $('.facilitiesContent table').each(function(i) {
      $(this).wrap( "<div class='tableWrapper'></div>" );
    })
  }
  if ($('.facilitiesFullContent table').length > 0) {
    $('.facilitiesFullContent table').each(function(i) {
      $(this).wrap( "<div class='tableWrapper'></div>" );
    })
  }
}

function checkMobile()
{
	var winWidth = 0;
   winWidth = window.outerWidth;


	var pda_user_agent_list = new Array("2.0 MMP", "240320", "AvantGo","BlackBerry", "Blazer",
			"Cellphone", "Danger", "DoCoMo", "Elaine/3.0", "EudoraWeb", "hiptop", "IEMobile", "KYOCERA/WX310K", "LG/U990",
			"MIDP-2.0", "MMEF20", "MOT-V", "NetFront", "Newt", "Nintendo Wii", "Nitro", "Nokia",
			"Opera Mini", "Opera Mobi",
			"Palm", "Playstation Portable", "portalmmm", "Proxinet", "ProxiNet",
			"SHARP-TQ-GX10", "Small", "SonyEricsson", "Symbian OS", "SymbianOS", "TS21i-10", "UP.Browser", "UP.Link",
			"Windows CE", "WinWAP", "Android", "iPhone", "iPod", /*"iPad",*/ "Windows Phone", "HTC"/*, "GTB", "Tablet PC"*/);
	var pda_app_name_list = new Array("Microsoft Pocket Internet Explorer");

	var user_agent = navigator.userAgent.toString();
	for (var i=0; i<pda_user_agent_list.length; i++) {
		if (user_agent.indexOf(pda_user_agent_list[i]) >= 0) {

			if(winWidth <= 750){
				return true;
			}


		}
	}
	var appName = navigator.appName.toString();
	for (var i=0; i<pda_app_name_list.length; i++) {
		if (user_agent.indexOf(pda_app_name_list[i]) >= 0) {

			if(winWidth <= 750){
				return true;
			}
		}
	}

	//check devise

	return false;
}

function unloadingWebsite() {
    if ($('html').hasClass('isPopup')) {
      $('header .nav-btn').trigger('click');
    }
    document.body.classList.add("unloaded");
}
window.addEventListener("pagehide", function() {
    unloadingWebsite();
});
window.addEventListener("pageshow", function() {
    unloadingWebsite();
});


'use strict';
// jquery.onscreen 2018-01-22 https://github.com/adaptlearning/jquery.onscreen

(function() {

    //ENUMERATION SUPPORT
    function ENUM(e){for(var i=0,l=e.length;i<l;i++){var n=e[i].toLowerCase();this[n]=(new Number(i));this[n].string=n;}}

    //handler id generation
    var expando = {
        index: 0,

        check: function(element) {
            //check that the element has a valid jquery expando property, or make one

            var hasExpando = (element[$.expando]);
            if (hasExpando) return;

            element[$.expando] = ++expando.index;

        },

        make: function(element, data) {
            //make a unique event id from the element's expando property and the event handler guid

            expando.check(element);
            return data.guid + "-" + element[$.expando];

        }
    };

    //handler functions
    var handlers = {
        //types definition
        TYPE: new ENUM(["onscreen", "inview"]),
        INVIEW_STATES: new ENUM(["none", "top", "bottom", "left", "right", "both"]),

        registered: [],
        shouldReProcess: true,

        register: function(element, data, type) {
            var isLocked = locking.isLocked();

            var $element = $(element);
            handlers.registered.push({
                id: expando.make(element, data),
                data: data,
                $element: $element,
                type: type,
                _onscreen: isLocked ? null : measurements.get($element).uniqueMeasurementId,
                _hasTriggered: false
            });
            handlers.shouldReProcess = true;

        },

        unregister: function(element, data, type) {

            var registered = handlers.registered;

            var findId = expando.make(element, data);
            for (var i = registered.length-1, l = -1; i > l; i--) {
                var item = registered[i]
                if (item.id != findId || item.type != type) continue;
                registered.splice(i,1);
                handlers.shouldReProcess = true;
            }

        },

        process: function() {

            var registered = handlers.registered;
            var registeredCount;

            handlers.shouldReProcess = true;
            while (handlers.shouldReProcess) {
                handlers.shouldReProcess = false;

                registeredCount = registered.length;
                if  (registeredCount == 0) return;

                for (var i = 0; i < registeredCount; i++) {
                    var item = registered[i];
                    var measure = measurements.get(item.$element);

                    //check if measure has the same values as last
                    var wasPreviouslyMeasured = (item._onscreen !== undefined);

                    if (wasPreviouslyMeasured && item._hasTriggered) {
                        var hasMeasureChanged = (item._onscreen != measure.uniqueMeasurementId);
                        if (!hasMeasureChanged) {
                            continue;
                        }
                    }

                    item._onscreen = measure.uniqueMeasurementId;
                    item._hasTriggered = true;

                    switch (item.type) {
                    case handlers.TYPE.onscreen:
                        handlers.processOnScreen(item, measure);
                        break;
                    case handlers.TYPE.inview:
                        handlers.processInView(item, measure);
                    }
                    if (handlers.shouldReProcess) {
                        break;
                    }
                }
            }

        },

        processOnScreen: function(item, measure) {

            item.$element.trigger('onscreen', measure);

        },

        processInView: function(item, measure) {

            var isTopOnScreen = (measure.percentFromTop >= 0 && measure.percentFromTop <= 100);
            var isBottomOnScreen = (measure.percentFromBottom >= 0 && measure.percentFromBottom <= 100);
            var isLeftOnScreen = (measure.percentFromLeft >= 0 && measure.percentFromLeft <= 100);
            var isRightOnScreen = (measure.percentFromRight >= 0 && measure.percentFromRight <= 100);

            var visiblePartY;
            if (isTopOnScreen && isBottomOnScreen) visiblePartY = handlers.INVIEW_STATES.both.string;
            else if (isTopOnScreen) visiblePartY = handlers.INVIEW_STATES.top.string;
            else if (isBottomOnScreen) visiblePartY = handlers.INVIEW_STATES.bottom.string;
            else visiblePartY = handlers.INVIEW_STATES.none.string;

            var visiblePartX;
            if (isLeftOnScreen && isRightOnScreen) visiblePartX = handlers.INVIEW_STATES.both.string;
            else if (isLeftOnScreen) visiblePartX = handlers.INVIEW_STATES.left.string;
            else if (isRightOnScreen) visiblePartX = handlers.INVIEW_STATES.right.string;
            else visiblePartX = handlers.INVIEW_STATES.none.string;

            var inviewState = [
                measure.onscreen, //inview true/false
                visiblePartX, //left, right, both, none
                visiblePartY //top, bottom, both, none
            ];

            if (item._inviewPreviousState !== undefined && config.options.allowScrollOver ) {
                //this is for browsers which pause javascript execution on scroll

                //check previous state and current state
                var wasScrolledOver = (item._measurePreviousState.percentFromBottom <= 100 && measure.percentFromBottom >= 100 );

                //if inview state hasn't changed, don't retrigger event
                if (item._inviewPreviousState[0] == inviewState[0] &&
                    item._inviewPreviousState[1] == inviewState[1] &&
                    item._inviewPreviousState[2] == inviewState[2] &&
                    !wasScrolledOver) return;

                if (wasScrolledOver) {
                    //make sure to trigger a scrolled over both top and bottom event
                    inviewState[0] = true;
                    inviewState[1] = "both";
                    inviewState[2] = "both";
                }
            }

            item._inviewPreviousState = inviewState;
            item._measurePreviousState = measure;

            item.$element.trigger('inview', inviewState );

        }
    };

    //checking loop management
    var loop = {

        lastStartEvent: 0,
        timeoutHandle: null,
        intervalDuration: 100,
        hasRaf: false,

        start: function() {

            loop.lastStartEvent = (new Date()).getTime();
            loop.repeat();

        },

        repeat: function() {

            loop.stop();

            if (loop.hasRaf) {
                loop.timeoutHandle = requestAnimationFrame(loop.main);
            } else {
                loop.timeoutHandle = setTimeout(loop.main, loop.intervalDuration);
            }

        },

        hasExpired: function() {

            var timeSinceLast = (new Date()).getTime() - loop.lastStartEvent;
            if (timeSinceLast < 1500) return;

            loop.stop()
            return true;
        },

        isThrottled: function() {
            var passedTime = (new Date()).getTime() - loop.lastMain;
            if (passedTime > loop.intervalDuration) return false;
            return true;
        },

        lastMain: (new Date()).getTime(),

        main: function() {

            if (loop.isThrottled()) {
                loop.repeat();
                return;
            }

            loop.lastMain = (new Date()).getTime();

            if (loop.hasExpired()) return;

            if (handlers.registered.length == 0) {
                //nothing to check
                loop.stop();
                //slow down to save cycles
                loop.intervalDuration = 200;
                loop.repeat();
            } else {
                //something to check
                loop.stop();
                //speed up to make more responsive
                loop.intervalDuration = 100;
                loop.repeat();
            }

            if (locking.isLocked()) return;

            handlers.process();

        },

        stop: function() {

            var intervalAttached = (loop.timeoutHandle !== null);
            if (!intervalAttached) return;

            if (loop.hasRaf) {
                cancelAnimationFrame(loop.timeoutHandle);
                loop.timeoutHandle = null;
            } else {
                clearTimeout(loop.timeoutHandle);
                loop.timeoutHandle = null;
            }

        }

    };

    //jQuery element + event handler attachment / removal
    $.extend($.event.special, {

        onscreen: {

            noBubble: true,

            add: function(data) {
                handlers.register(this, data, handlers.TYPE.onscreen);
            },

            remove: function(data) {
                handlers.unregister(this, data, handlers.TYPE.onscreen);
            }

        },

        inview: {

            noBubble: true,

            add: function(data) {
                handlers.register(this, data, handlers.TYPE.inview);
            },

            remove: function(data) {
                handlers.unregister(this, data, handlers.TYPE.inview);
            }

        }

    });

    //jQuery interfaces
    //element functions
    $.extend($.fn, {

        onscreen: function onscreen(callback) {

            if (callback) {
                //standard event attachment jquery api behaviour
                this.on("onscreen", callback);
                return this;
            }

            return measurements.get(this);

        },

        inview: function inview(callback) {

            if (callback) {
                //standard event attachment jquery api behaviour
                this.on("inview", callback);
                return this;
            }

            return measurements.get(this);

        }

    });

    //interface to allow for inview/onscreen to be disabled
    var locking =  {
        locks: [],

        lock: function(name) {

            if (locking.isLocked(name)) return;
            locking.locks.push(name);

        },

        unlock: function(name) {

            if (!locking.isLocked(name)) return;

            for (var i = 0, l = locking.locks.length; i < l; i++) {
                var lock = locking.locks[i];
                if (lock == name) {
                    locking.locks.splice(i,1);
                    break;
                }
            }

            loop.start();

        },

        isLocked: function(name) {

            if (!name) return (locking.locks.length > 0);

            for (var i = 0, l = locking.locks.length; i < l; i++) {
                var lock = locking.locks[i];
                if (lock == name) {
                    return true;
                }
            }
            return false;

        }

    };

    var config = {

        options: {
            allowScrollOver: true
        },

        config: function(options) {
            if (typeof options !== "object") return;

            $.extend(config.options, options);

        }

    };


    //force an inview check - standard trigger event jquery api behaviour
    $.inview = $.onscreen = function() {
        loop.start();
    };
    //attach locking interface to $.inview.lock(name); etc
    $.extend($.inview, locking, config);

    //window size handlers
    var wndw = {

        $el: $(window),
        height: null,
        width: null,
        heightRatio: null,
        widthRatio: null,

        resize: function() {
            wndw.height = window.innerHeight || wndw.$el.height();
            wndw.width = window.innerWidth || wndw.$el.width();
            wndw.heightRatio = (100 / wndw.height);
            wndw.widthRatio = (100 / wndw.width);
            loop.start();
        }

    };

    var measurements = {

        featureDetect: function() {

            loop.hasRaf = (window.requestAnimationFrame && window.cancelAnimationFrame);

        },

        get: function get($element) {

            if ($element.length == 0) return;

            var el = $element[0];
            var offset;

            try {
                offset = el.getBoundingClientRect();
            } catch (e) {
                // IE11 throws an error if the element isn't present in the DOM
                offset = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
            }

            var height = offset.height;
            var width = offset.width;

            //topleft from topleft of window
            var top = offset["top"];
            var left = offset["left"];

            //bottomright from bottomright of window
            var bottom = wndw.height - (top + height);
            var right = wndw.width - (left + width)

            //percentages of above
            var percentFromTop = Math.round(wndw.heightRatio * top);
            var percentFromLeft = Math.round(wndw.widthRatio * left);
            var percentFromBottom = Math.round(wndw.heightRatio * bottom);
            var percentFromRight = Math.round(wndw.widthRatio * right);

            //inview
            var inviewHorizontal = null;
            if (left+width > 0 && right < 0 && left < 0) {
                inviewHorizontal = width;
            } else if (left < 0) { //offscreen left
                inviewHorizontal = (width + left);
            } else if (left + width > wndw.width) { //offscreen right
                inviewHorizontal = (wndw.width - left);
            } else { //fully inscreen
                inviewHorizontal = width;
            }

            var inviewVertical = null;
            if (top+height > 0 && bottom < 0 && top < 0) {
                inviewVertical = height;
            } else if (top < 0) { //offscreen top
                inviewVertical = (height + top);
            } else if (top + height > wndw.height) { //offscreen bottom
                inviewVertical = (wndw.height - top);
            } else { //fully inscreen
                inviewVertical = height;
            }

            // cap floor at 0 - cannot have negative inviews.
            if (inviewVertical < 0) inviewVertical = 0;
            if (inviewHorizontal < 0) inviewHorizontal = 0;

            var percentInviewVertical = Math.round((100 / height) * inviewVertical);
            var percentInviewHorizontal = Math.round((100 / width) * inviewHorizontal);

            var elementArea = height * width;
            var inviewArea = inviewVertical * inviewHorizontal;
            var percentInview = Math.round((100 / elementArea) * inviewArea);

            var onscreen = true;
            var offScreenSide = (percentFromRight > 100 || percentFromLeft > 100 || percentFromBottom > 100 || percentFromTop > 100);
            if (offScreenSide) onscreen = false;

            var hasNoSize = (height <= 0 && width <= 0);
            if (hasNoSize) onscreen = false;

            var cssHidden = measurements.isElementHidden(el);
            if (cssHidden) onscreen = false;

            if (onscreen) {

                // perform some extra checks to make sure item is onscreen
                var parents = measurements.getParents(el);

                // go through all the parents except the html tag
                for (var i = 0, l = parents.length-1; i < l; i++) {
                    var parent = parents[i];

                    cssHidden = measurements.isElementHidden(parent);

                    // check if parents are visibility hidden or display none
                    if (cssHidden) {
                        onscreen = false;
                        break;
                    }

                    // check if child is out of bounds inside its parent
                    var isOutOfBounds = measurements.isOutOfBounds(el, parent)
                    if (isOutOfBounds) {
                        onscreen = false;
                        break;
                    }

                }

            }

            var uniqueMeasurementId = ""+top+left+bottom+right+height+width+wndw.height+wndw.width+onscreen;

            return {
                top: top,
                left: left,
                bottom: bottom,
                right: right,
                percentFromTop: percentFromTop,
                percentFromLeft: percentFromLeft,
                percentFromBottom: percentFromBottom,
                percentFromRight: percentFromRight,
                percentInview: percentInview,
                percentInviewHorizontal: percentInviewHorizontal,
                percentInviewVertical: percentInviewVertical,
                onscreen: onscreen,
                uniqueMeasurementId: uniqueMeasurementId,
                timestamp: (new Date()).getTime()
            };

        },

        getParents: function(element) {
            var parents = [];
            var parent;
            while (parent = element.parentElement) {
                parents.push(parent);
                element = parent;
            }
            return parents;
        },

        isElementHidden: function(element) {
            var cssHidden = (element.style.display == "none" || element.style.visibility == "hidden");
            if (cssHidden) return true;

            var style = window.getComputedStyle(element, null);
            cssHidden = (style.display == "none" || style.visibility == "hidden");
            return cssHidden;
        },

        isOutOfBounds: function(element, parent) {

            var isScrollWidthOverflowing = (parent.clientWidth < parent.scrollWidth);
            var isScrollHeightOverflowing = (parent.clientHeight < parent.scrollHeight);
            var isOverflowing = (isScrollWidthOverflowing || isScrollHeightOverflowing);

            var $parent = $(parent);

            if (!isOverflowing || ($parent.css("overflow") === "visible")) {
                return false;
            }

            var $element = $(element);

            var childPos = $element.offset();
            var parentPos = $parent.offset();

            var childOffsetTop = (childPos.top - parentPos.top);
            var childOffsetLeft = (childPos.left - parentPos.left);
            var childOffsetBottom = (childOffsetTop + element.clientHeight);
            var childOffsetRight = (childOffsetLeft + element.clientWidth);

            // check inclusive of bounding rectangle edges
            var isOutOfBounds = (childOffsetTop >= parent.clientHeight
                || childOffsetLeft >= parent.clientWidth
                || childOffsetBottom <= 0
                || childOffsetRight <= 0);

            return isOutOfBounds;

        }

    };  

   


    //attach event handlers
    $(window).on({
        "touchmove scroll mousedown keydown": loop.start,
        "resize": wndw.resize
    });

    $(measurements.featureDetect);
    wndw.resize();

})();
